import axios from "axios";
import { GPROCESS_SERVICE_URL } from "../request/wsCode";
import { withSsoAuthorization } from "src/helpers/auth";
import { whenGprocessTokenReady } from "src/hooks/useGetGprocessToken";

export const RequestApiPrivate = axios.create({
  baseURL: GPROCESS_SERVICE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// XẾP HÀNG GỌI LẠI SAU: token g-process được sinh BẤT ĐỒNG BỘ sau khi login
// (generateGprocessToken, gọi fire-and-forget ở authSlice). Request bắn quá sớm (vd Sidebar gọi
// manager-status lúc app shell mount) sẽ không có Authorization → 401. Interceptor dưới đây CHỜ
// tới khi token sẵn sàng rồi mới gửi (gắn token vừa set), thay vì để request 401.
RequestApiPrivate.interceptors.request.use(async (config: any) => {
  const url = config?.url || "";
  const alreadyHasAuth =
    config?.headers?.Authorization ||
    RequestApiPrivate.defaults.headers.common["Authorization"];
  // Bỏ qua chính request lấy token (dùng SSO token riêng) + request đã có Authorization.
  if (url.includes("generate-token") || alreadyHasAuth) {
    return config;
  }
  // Chờ token (tối đa 15s để không treo nếu login lỗi), rồi gắn token vừa set lên request.
  await Promise.race([
    whenGprocessTokenReady(),
    new Promise<void>((resolve) => setTimeout(resolve, 15000)),
  ]);
  const token = RequestApiPrivate.defaults.headers.common["Authorization"];
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = token;
  }
  return config;
});

export function updateAxiosHeaderGprocessAcceptLanguage(locale: string): void {
  RequestApiPrivate.defaults.headers.common["Accept-Language"] = `${locale}`;
}

export const gprocessApi = {
  /** `POST /generate-token` (G-Process) — xác thực bằng SSO access token. */
  generateToken: async function (
    json: any,
    ssoAccessToken: string
  ): Promise<any> {
    let params = {
      id: json?.authUser?.id,
      expired_in: json?.expired_in,
    };
    try {
      const res = await RequestApiPrivate.post(
        "generate-token",
        params,
        withSsoAuthorization(ssoAccessToken)
      );
      if (res) {
        return res.data;
      }
    } catch (error) {
      throw error;
    }
  },
};
